var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 1 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 15.8008,
    r: 12,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.1758C12.0078 22.1758 11.625 21.793 11.625 21.3008H10.75C10.75 22.2852 11.5156 23.0508 12.5 23.0508C13.457 23.0508 14.25 22.2852 14.25 21.3008H13.375C13.375 21.793 12.9648 22.1758 12.5 22.1758ZM18.2148 18.2109C17.4492 17.5 16.875 16.7344 16.875 14.1367C16.875 11.9766 15.125 10.1992 12.9375 9.98047V9.48828C12.9375 9.26953 12.7188 9.05078 12.5 9.05078C12.2539 9.05078 12.0625 9.26953 12.0625 9.48828V9.98047C9.84766 10.1992 8.09766 11.9766 8.09766 14.1367C8.09766 16.7344 7.52344 17.5 6.75781 18.2109C6.375 18.5938 6.26562 19.1406 6.45703 19.6328C6.64844 20.125 7.14062 20.4258 7.6875 20.4258H17.3125C17.832 20.4258 18.3242 20.125 18.5156 19.6328C18.707 19.1406 18.5977 18.5938 18.2148 18.2109ZM17.3125 19.5508H7.6875C7.27734 19.5508 7.08594 19.1133 7.35938 18.8398C8.31641 17.9375 8.97266 16.9258 8.97266 14.1367C8.97266 12.3047 10.5586 10.8008 12.5 10.8008C14.4141 10.8008 16 12.3047 16 14.1367C16 16.9258 16.6562 17.9375 17.6133 18.8398C17.8867 19.1133 17.6953 19.5508 17.3125 19.5508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.65bdc7c6f9dbd00c1e970294cfbdf3ee.svg";
export { ForwardRef as ReactComponent };